package com.yogaaicoach.pages.payment.ui

import web.location.location

actual fun stripeRedirect(url: String) {
    location.href = url
}

actual val usesPlayBilling: Boolean = false

actual suspend fun launchPlayBillingPurchase(plan: SubscriptionPlan): PlayBillingResult =
    PlayBillingResult.Failed("Google Play Billing is not available on web")

actual fun openPlayStoreSubscriptions() = Unit
